module.exports = __webpack_public_path__ + "img/ATL.a2c2919b.svg";